
import React from 'react'
import Typography from '@mui/material/Typography'
import { Container } from '@mui/material'

export default function VersionInfo(props: Props) {
  return (
      <Typography
          component="span"
          variant="body1"
          noWrap
          sx={{ fontSize: 'smaller', marginBottom: '4em' }}
          className={""}
        >
        <span sx={{marginRight: '1em'}}>ODAP Ver. {process.env.REACT_APP_VERSION}  |  </span>
	<span sx={{paddingRight: '1em'}}>RTI Ver. {process.env.REACT_APP_RTI_VERSION}</span>
        { process.env.REACT_APP_WORKSPACE != "production" && <span>  |  {process.env.REACT_APP_WORKSPACE}</span> }
      </Typography>
  )
}
